// extracted by mini-css-extract-plugin
export var active = "_iy-2";
export var recordingDot = "_iy-1";
export var recordingIndicator = "_iy-0";